// extracted by mini-css-extract-plugin
export default {"home_container":"style_home_container__81eO9"};